import { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { translations } from "./translations";
import blogPosts from "./data/blogPosts";

// Re-export blogPosts for backward compatibility
export { blogPosts };

// Logo URL
const LOGO_ICON = "https://customer-assets.emergentagent.com/job_event-booking-pro-7/artifacts/6r7gbjry_logo%20800x800.png";

// Social Media Icons
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
);

// Blog page component
export const BlogPage = ({ lang, setLang }) => {
  const t = translations[lang];
  // Sort posts by date (newest first)
  const posts = Object.values(blogPosts).sort((a, b) => new Date(b.date) - new Date(a.date));
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Scroll to top on mount
    window.scrollTo(0, 0);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app" data-testid="blog-page">
      <Helmet>
        <title>{lang === 'tr' ? 'Blog | Nova Iberian - İspanya Oturum Rehberi' : lang === 'en' ? 'Blog | Nova Iberian - Spain Residence Guide' : 'Blog | Nova Iberian - Guía de Residencia en España'}</title>
        <meta name="description" content={lang === 'tr' ? 'İspanya oturum izni, vize türleri, yaşam maliyeti ve daha fazlası hakkında güncel blog yazıları. Nova Iberian uzman içerikleri.' : lang === 'en' ? 'Latest blog posts about Spain residence permits, visa types, cost of living and more. Nova Iberian expert content.' : 'Últimos artículos sobre permisos de residencia en España, tipos de visa, coste de vida y más. Contenido experto de Nova Iberian.'} />
        <link rel="canonical" href="https://novaiberian.com/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={lang === 'tr' ? 'Blog | Nova Iberian - İspanya Oturum Rehberi' : lang === 'en' ? 'Blog | Nova Iberian - Spain Residence Guide' : 'Blog | Nova Iberian - Guía de Residencia en España'} />
        <meta property="og:description" content={lang === 'tr' ? 'İspanya oturum izni, vize türleri ve yaşam rehberi hakkında uzman içerikler.' : lang === 'en' ? 'Expert content about Spain residence permits, visa types and living guide.' : 'Contenido experto sobre permisos de residencia en España, tipos de visa y guía de vida.'} />
        <meta property="og:url" content="https://novaiberian.com/blog" />
        <meta property="og:image" content="https://novaiberian.com/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@IberianNov846" />
        <meta name="twitter:title" content={lang === 'tr' ? 'Blog | Nova Iberian - İspanya Oturum Rehberi' : lang === 'en' ? 'Blog | Nova Iberian - Spain Residence Guide' : 'Blog | Nova Iberian - Guía de Residencia en España'} />
        <meta name="twitter:description" content={lang === 'tr' ? 'İspanya oturum izni, vize türleri ve yaşam rehberi hakkında uzman içerikler.' : lang === 'en' ? 'Expert content about Spain residence permits, visa types and living guide.' : 'Contenido experto sobre permisos de residencia en España, tipos de visa y guía de vida.'} />
        <meta name="twitter:image" content="https://novaiberian.com/og-image.png" />
      </Helmet>
      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="nav-logo-icon" />
            <span className="nav-logo-text">Nova <span>Iberian</span></span>
          </Link>
          
          <div className="nav-links">
            <Link to="/#hizmetler">{t.nav.services}</Link>
            <Link to="/can-cagatay-celikkol">{t.nav.about}</Link>
            <Link to="/#referanslar">{t.nav.testimonials}</Link>
            <Link to="/#ispanya-bilgisi">{t.nav.guide}</Link>
            <Link to="/blog">{t.nav.blog}</Link>
            <Link to="/#iletisim">{t.nav.contact}</Link>
            
            {/* Social Media Icons in Nav */}
            <div className="nav-social-icons">
              <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
              <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
              <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
              <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
              <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
            </div>
          </div>
          
          <div className="nav-right">
            <div className="lang-dropdown">
              <button 
                className="lang-dropdown-btn"
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
              >
                <span className="lang-code">{lang === 'tr' ? 'TR' : lang === 'en' ? 'EN' : 'ES'}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>
              {langDropdownOpen && (
                <div className="lang-dropdown-menu">
                  <button 
                    className={`lang-dropdown-item ${lang === 'tr' ? 'active' : ''}`}
                    onClick={() => { setLang('tr'); setLangDropdownOpen(false); }}
                  >
                    Türkçe
                  </button>
                  <button 
                    className={`lang-dropdown-item ${lang === 'en' ? 'active' : ''}`}
                    onClick={() => { setLang('en'); setLangDropdownOpen(false); }}
                  >
                    English
                  </button>
                  <button 
                    className={`lang-dropdown-item ${lang === 'es' ? 'active' : ''}`}
                    onClick={() => { setLang('es'); setLangDropdownOpen(false); }}
                  >
                    Español
                  </button>
                </div>
              )}
            </div>
            <Link to="/#randevu" className="btn-nav">{t.nav.appointment}</Link>
            
            <button 
              className="mobile-menu-btn" 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
        
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-social-icons">
            <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
            <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
            <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
            <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
            <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
          </div>
          <Link to="/#hizmetler" onClick={() => setMobileMenuOpen(false)}>{t.nav.services}</Link>
          <Link to="/can-cagatay-celikkol" onClick={() => setMobileMenuOpen(false)}>{t.nav.about}</Link>
          <Link to="/#referanslar" onClick={() => setMobileMenuOpen(false)}>{t.nav.testimonials}</Link>
          <Link to="/#ispanya-bilgisi" onClick={() => setMobileMenuOpen(false)}>{t.nav.guide}</Link>
          <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>{t.nav.blog}</Link>
          <Link to="/#iletisim" onClick={() => setMobileMenuOpen(false)}>{t.nav.contact}</Link>
        </div>
      </nav>

      {/* Blog Header Section */}
      <section className="blog-header-section">
        <div className="section-inner">
          <div className="sec-eyebrow">BLOG</div>
          <h2>
            {lang === 'tr' && <>İspanya'ya dair <em>rehber</em> yazılar.</>}
            {lang === 'en' && <>Guide articles about <em>Spain</em>.</>}
            {lang === 'es' && <>Artículos guía sobre <em>España</em>.</>}
          </h2>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-posts-section">
        <div className="section-inner">
          <div className="blog-grid-new">
            {posts.map((post) => {
              // Use language-specific slug if available
              const postSlug = post.slugs?.[lang] || post.id;
              return (
                <Link to={`/blog/${postSlug}`} key={post.id} className="blog-card-new" data-testid={`blog-card-${post.id}`}>
                  <div className="blog-card-tag-new">{post.tag[lang]}</div>
                  <h3 className="blog-card-title-new" dangerouslySetInnerHTML={{ __html: post.title[lang] }} />
                  <p className="blog-card-excerpt-new">{post.excerpt[lang]}</p>
                  <div className="blog-card-footer-new">
                    <div className="blog-card-meta-new">
                      <span className="blog-card-date-new">
                        {new Date(post.date).toLocaleDateString(lang === 'tr' ? 'tr-TR' : lang === 'en' ? 'en-US' : 'es-ES')}
                      </span>
                      <span className="blog-card-dot">•</span>
                      <span className="blog-card-readtime-new">{post.readTime[lang]}</span>
                    </div>
                    <span className="blog-card-link-new">
                      {lang === 'tr' ? 'Devamını Oku →' : lang === 'en' ? 'Read More →' : 'Leer Más →'}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-inner">
          <Link to="/" className="footer-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="footer-logo-icon" />
            <span className="footer-logo-text">Nova <span>Iberian</span></span>
          </Link>
          <div className="footer-text">© 2026 Nova Iberian. {t.footer.rights}</div>
          <div className="footer-links">
            <Link to="/aydinlatma-metni">{lang === 'tr' ? 'Aydınlatma Metni' : lang === 'en' ? 'Privacy Notice' : 'Aviso de Privacidad'}</Link>
            <Link to="/cerez-politikasi">{lang === 'tr' ? 'Çerez Politikası' : lang === 'en' ? 'Cookie Policy' : 'Política de Cookies'}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Single blog post component
export const BlogPost = ({ lang, setLang }) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const initialLangSynced = useRef(false);
  const prevLangRef = useRef(lang);
  
  // Find post by any language slug and detect the language from URL
  const findPostBySlug = (urlSlug) => {
    // Search through all posts for matching slug in any language
    for (const [postId, postData] of Object.entries(blogPosts)) {
      if (postData.slugs) {
        for (const [langCode, langSlug] of Object.entries(postData.slugs)) {
          if (langSlug === urlSlug) {
            return { post: postData, canonicalId: postId, detectedLang: langCode };
          }
        }
      }
    }
    // Fallback: direct match with post ID (for posts without slugs)
    if (blogPosts[urlSlug]) return { post: blogPosts[urlSlug], canonicalId: urlSlug, detectedLang: 'tr' };
    
    return { post: null, canonicalId: null, detectedLang: null };
  };
  
  const { post, canonicalId, detectedLang } = findPostBySlug(slug);
  
  // Sync language state with URL-detected language ONLY on initial load
  useEffect(() => {
    if (!initialLangSynced.current && detectedLang && detectedLang !== lang) {
      setLang(detectedLang);
    }
    initialLangSynced.current = true;
  }, [detectedLang, lang, setLang]);
  
  const t = translations[lang];
  const localizedSlug = post?.slugs?.[lang] || canonicalId || slug;
  
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    window.scrollTo(0, 0);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Redirect to correct language URL ONLY when user manually changes language
  useEffect(() => {
    // Only redirect if language actually changed (user clicked language button)
    if (prevLangRef.current !== lang && post && localizedSlug && slug !== localizedSlug) {
      navigate(`/blog/${localizedSlug}`, { replace: true });
    }
    prevLangRef.current = lang;
  }, [lang, localizedSlug, slug, navigate, post]);

  if (!post) {
    return (
      <div className="app">
        <div className="section-inner" style={{ paddingTop: '150px', textAlign: 'center' }}>
          <h1>{lang === 'tr' ? 'Yazı Bulunamadı' : lang === 'en' ? 'Post Not Found' : 'Artículo No Encontrado'}</h1>
          <Link to="/blog" className="btn-primary" style={{ marginTop: '24px', display: 'inline-block' }}>
            {lang === 'tr' ? '← Blog\'a Dön' : lang === 'en' ? '← Back to Blog' : '← Volver al Blog'}
          </Link>
        </div>
      </div>
    );
  }

  // Use detected language from URL for meta tags (SEO), user preference for UI
  const metaLang = detectedLang || lang;

  return (
    <div className="app" data-testid="blog-post-page">
      <Helmet>
        <title>{`${post.title[metaLang].replace(/<[^>]*>/g, '')} | Nova Iberian Blog`}</title>
        <meta name="description" content={post.excerpt[metaLang]} />
        <link rel="canonical" href={`https://novaiberian.com/blog/${post?.slugs?.[metaLang] || slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={`${post.title[metaLang].replace(/<[^>]*>/g, '')} | Nova Iberian`} />
        <meta property="og:description" content={post.excerpt[metaLang]} />
        <meta property="og:url" content={`https://novaiberian.com/blog/${post?.slugs?.[metaLang] || slug}`} />
        <meta property="og:image" content="https://novaiberian.com/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="article:published_time" content={post.date} />
        <meta property="article:author" content="Nova Iberian" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@IberianNov846" />
        <meta name="twitter:title" content={`${post.title[metaLang].replace(/<[^>]*>/g, '')} | Nova Iberian`} />
        <meta name="twitter:description" content={post.excerpt[metaLang]} />
        <meta name="twitter:image" content="https://novaiberian.com/og-image.png" />
      </Helmet>
      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="nav-logo-icon" />
            <span className="nav-logo-text">Nova <span>Iberian</span></span>
          </Link>
          
          <div className="nav-links">
            <Link to="/#hizmetler">{t.nav.services}</Link>
            <Link to="/can-cagatay-celikkol">{t.nav.about}</Link>
            <Link to="/#referanslar">{t.nav.testimonials}</Link>
            <Link to="/#ispanya-bilgisi">{t.nav.guide}</Link>
            <Link to="/blog">{t.nav.blog}</Link>
            <Link to="/#iletisim">{t.nav.contact}</Link>
            
            {/* Social Media Icons in Nav */}
            <div className="nav-social-icons">
              <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
              <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
              <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
              <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
              <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
            </div>
          </div>
          
          <div className="nav-right">
            <div className="lang-dropdown">
              <button 
                className="lang-dropdown-btn"
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
              >
                <span className="lang-code">{lang === 'tr' ? 'TR' : lang === 'en' ? 'EN' : 'ES'}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>
              {langDropdownOpen && (
                <div className="lang-dropdown-menu">
                  <button 
                    className={`lang-dropdown-item ${lang === 'tr' ? 'active' : ''}`}
                    onClick={() => { setLang('tr'); setLangDropdownOpen(false); }}
                  >
                    Türkçe
                  </button>
                  <button 
                    className={`lang-dropdown-item ${lang === 'en' ? 'active' : ''}`}
                    onClick={() => { setLang('en'); setLangDropdownOpen(false); }}
                  >
                    English
                  </button>
                  <button 
                    className={`lang-dropdown-item ${lang === 'es' ? 'active' : ''}`}
                    onClick={() => { setLang('es'); setLangDropdownOpen(false); }}
                  >
                    Español
                  </button>
                </div>
              )}
            </div>
            <Link to="/#randevu" className="btn-nav">{t.nav.appointment}</Link>
            
            <button 
              className="mobile-menu-btn" 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
        
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-social-icons">
            <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
            <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
            <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
            <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
            <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
          </div>
          <Link to="/#hizmetler" onClick={() => setMobileMenuOpen(false)}>{t.nav.services}</Link>
          <Link to="/can-cagatay-celikkol" onClick={() => setMobileMenuOpen(false)}>{t.nav.about}</Link>
          <Link to="/#referanslar" onClick={() => setMobileMenuOpen(false)}>{t.nav.testimonials}</Link>
          <Link to="/#ispanya-bilgisi" onClick={() => setMobileMenuOpen(false)}>{t.nav.guide}</Link>
          <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>{t.nav.blog}</Link>
          <Link to="/#iletisim" onClick={() => setMobileMenuOpen(false)}>{t.nav.contact}</Link>
        </div>
      </nav>

      {/* Blog Post Header - Service Style Hero */}
      <article className="blog-post">
        <header className="blog-post-hero">
          <div className="blog-post-hero-content">
            <Link to="/blog" className="blog-back-link">
              ← {lang === 'tr' ? 'Tüm Blog Yazıları' : lang === 'en' ? 'All Blog Posts' : 'Todos los Artículos'}
            </Link>
            <h1 dangerouslySetInnerHTML={{ __html: post.title[lang] }} />
            <p className="blog-post-subtitle">{post.excerpt[lang]}</p>
            <div className="blog-post-meta-hero">
              <span>{new Date(post.date).toLocaleDateString(lang === 'tr' ? 'tr-TR' : lang === 'en' ? 'en-US' : 'es-ES')}</span>
              <span>•</span>
              <span>{post.readTime[lang]}</span>
              <span>•</span>
              <span>{post.tag[lang]}</span>
            </div>
          </div>
        </header>

        {/* Blog Post Content */}
        <div className="blog-post-content-area">
          <div className="blog-post-content-inner">
            <div className="blog-post-body" dangerouslySetInnerHTML={{ __html: post.content[lang] }} />
            
            {/* CTA */}
            <div className="blog-post-cta">
              <h3>{lang === 'tr' ? 'Uzman Desteği Alın' : lang === 'en' ? 'Get Expert Support' : 'Obtén Apoyo Experto'}</h3>
              <p>{lang === 'tr' ? 'İspanya\'ya taşınma sürecinizde yanınızda olmak istiyoruz.' : lang === 'en' ? 'We want to be with you during your relocation to Spain.' : 'Queremos estar contigo durante tu mudanza a España.'}</p>
              <a href="/#randevu" className="btn-primary">
                {lang === 'tr' ? 'Randevu Al →' : lang === 'en' ? 'Book Appointment →' : 'Reservar Cita →'}
              </a>
            </div>
            
            {/* Back to Blog Link */}
            <div className="blog-bottom-nav">
              <Link to="/blog" className="blog-back-link">
                ← {lang === 'tr' ? 'Tüm Blog Yazıları' : lang === 'en' ? 'All Blog Posts' : 'Todos los Artículos'}
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-inner">
          <Link to="/" className="footer-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="footer-logo-icon" />
            <span className="footer-logo-text">Nova <span>Iberian</span></span>
          </Link>
          <div className="footer-text">© 2026 Nova Iberian. {t.footer.rights}</div>
          <div className="footer-links">
            <Link to="/aydinlatma-metni">{lang === 'tr' ? 'Aydınlatma Metni' : lang === 'en' ? 'Privacy Notice' : 'Aviso de Privacidad'}</Link>
            <Link to="/cerez-politikasi">{lang === 'tr' ? 'Çerez Politikası' : lang === 'en' ? 'Cookie Policy' : 'Política de Cookies'}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
